import WalletSelectorModal from "./WalletSelectorModal"

export default WalletSelectorModal
